import axios from "axios"
/**
 * 获得项目根路径(通过浏览器路径获取服务器基本地址，使用条件有限)
 *
 *  使用方法: baseUrl
 */
export let sy={
	bp: function() {
		var curWwwPath = window.document.location.href;
		var pathName = window.document.location.pathname;
		var pos = curWwwPath.indexOf(pathName);
		var localhostPath = curWwwPath.substring(0, pos);
		var projectName = pathName.substring(0, pathName.substr(1).indexOf('/') + 1);
		return (localhostPath + projectName);
	}
};

/**
 *
 *获取cookie
 *
 */
function getCookie(name)
{
	var arr,reg=new RegExp("(^| )"+name+"=([^;]*)(;|$)");
	if(arr=document.cookie.match(reg))
		return unescape(arr[2]);
	else
		return null;
}

// 创建 axios 实例
const request = axios.create({
    // API 请求的默认前缀
    baseURL: sy.bp(),   //process.env.VUE_APP_API_BASE_URL,
    timeout: 1000, // 请求超时时间10秒
    withCredentials: true,  //跨域是否携带cookie，后端服务同时配置Access-Control-Allow-Origin='指定域名'(不可设置为*)，响应头Access-Control-Allow-Credentials=true
})

// 异常拦截处理器
const errorHandler = (error) => {
  console.error(error)
  if (error.response) {
    switch(error.response.status){
		case 400:
			alert("错误请求，服务器不理解请求语法！");
			break;
		case 403:
			window.location.href="#/Login";
			return
			break;
		case 404:
			//alert("页面不存在！");
			break;
		case 500:
			alert("服务器内部错误，无法完成请求！");
			break;
		case 504:
			alert("访问超时！");
			break;
		default:
			alert(error.response.data.error_message);
			break;
	}
  }
  return Promise.reject(error)
}

// request interceptor
request.interceptors.request.use(config => {
  return config
}, errorHandler)

// response interceptor
request.interceptors.response.use((response) => {
   if(response.data.code === 2003){
		window.location.href="#/Login";
   }
  return response.data
}, errorHandler)




request({
	dataType : "JSON",
	headers:{
		'Content-type': 'application/json',
		"X-CSRFtoken": getCookie('csrftoken')  //解决403问题,后端Django框架要求，put和post和delete时choome浏览器取cookie随机csrf值带过去，火狐不需要。
	}
})

export default request






// WEBPACK FOOTER //
// ./static/js/API/http.js